import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ReadOnlyField from 'components/read_only_field';

export default class PropertyTypeInputs extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    hasError: PropTypes.bool,
    includeBlank: PropTypes.bool,
    propertySubtypeId: PropTypes.number,
    propertyTypeId: PropTypes.number,
    propertyTypes: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      subtypes: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired
      }))
    })).isRequired,
    readOnly: PropTypes.bool,
    renderInputWrapper: PropTypes.func,
    required: PropTypes.bool,
    onChange: PropTypes.func
  }

  static defaultProps = {
    onChange: () => { }
  }

  getPropertySubtypes = (propertyTypeId = this.props.propertyTypeId) => {
    const propertyType = this.props.propertyTypes.find(type => type.id === propertyTypeId);
    return (propertyType || this.props.propertyTypes[0] || {}).subtypes || [];
  }

  handlePropertyTypeIdChange = (event) => {
    const propertyTypeId = parseInt(event.target.value);
    const changes = { propertyTypeId, propertySubtypeId: null };

    if (propertyTypeId != null) {
      const subtypes = this.getPropertySubtypes(propertyTypeId);
      if (subtypes.length > 0) {
        changes.propertySubtypeId = subtypes[0].id;
      }
    }

    this.props.onChange(changes);
  }

  handlePropertySubtypeIdChange = (event) => {
    this.props.onChange({ propertySubtypeId: parseInt(event.target.value) });
  }

  render() {
    if (this.props.readOnly) {
      return (
        <React.Fragment>
          {this.renderReadOnlyPropertyType('Property Type', 'propertyTypeId', this.props.propertyTypes)}
          {this.renderReadOnlyPropertyType('Property Subtype', 'propertySubtypeId', this.getPropertySubtypes())}
        </React.Fragment>
      );
    }
    return <React.Fragment>
      {this.renderInput('propertyTypeId', 'Property Type', (
        <select
          className="form-select"
          disabled={this.props.disabled}
          name="propertyTypeId"
          value={this.props.propertyTypeId || ''}
          onChange={this.handlePropertyTypeIdChange}
        >
          {this.renderBlankOption()}
          {this.props.propertyTypes.map(type => (
            <option key={type.id} value={type.id}>{type.name}</option>
          ))}
        </select>
      ))}

      {this.renderInput('propertySubtypeId', 'Property Subtype', (
        <select
          className="form-select"
          disabled={this.props.disabled}
          name="propertySubtypeId"
          value={this.props.propertySubtypeId || ''}
          onChange={this.handlePropertySubtypeIdChange}
        >
          {this.renderBlankOption()}
          {this.getPropertySubtypes().map(subtype => (
            <option key={subtype.id} value={subtype.id}>{subtype.name}</option>
          ))}
        </select>
      ))}
    </React.Fragment>;
  }

  renderInput(name, label, input) {
    if (this.props.renderInputWrapper) {
      return this.props.renderInputWrapper(name, label, input);
    } else {
      return (
        <div className={classNames('form-group', { 'has-error': this.props.hasError, required: this.props.required })}>
          <label className="form-label">{label}</label>
          <div className="form-input-container">
            {input}
          </div>
        </div>
      );
    }
  }

  renderBlankOption() {
    if (this.props.includeBlank) {
      return <option disabled hidden value="" />;
    }
  }

  renderReadOnlyPropertyType(label, name, options) {
    const id = this.props[name];
    const option = options.find(type => type.id === id);
    return <ReadOnlyField label={label} name={name} value={option && option.name} />;
  }
}
